setInterval(function () {
    fetchNotifications();
}, 10000)
